module.exports = __webpack_public_path__ + "static/media/iconSegundary.2b58ce69.png";